export default {
  metadata: {
    version: '1.0.0',
    id: 'Rating-bar-item-1.0.0',
    name: 'JDSRatingBarItem'
  },
  hierarchy: {
    container: [
      {
        'start-container': ['start-icon']
      },
      {
        'end-container': ['end-icon']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{r_0}',
      behavior: {
        focus: {
          'border-width': '{r_1}',
          'border-color': '{r_2}'
        }
      }
    },
    'start-container': {
      'clip-first-half': true
    },
    'start-icon': {
      size: '{l}',
      color: '{primaryGrey80}',
      value: 'ic_star'
    },
    'end-container': {
      hidden: true,
      'clip-first-half': false,
      'z-index': 1
    },
    'end-icon': {
      size: '{l}',
      color: '{primaryGrey80}',
      value: 'ic_star'
    }
  },
  variant: {
    size: {
      small: {
        'start-icon': {
          size: '{r_3}'
        },
        'end-icon': {
          size: '{r_4}'
        }
      },
      large: {
        'start-icon': {
          size: '{r_5}'
        },
        'end-icon': {
          size: '{r_6}'
        }
      }
    },
    isInteractive: {
      false: {
        container: {
          disabled: true
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{r_7}'
        }
      }
    },
    isHalfRated: {
      true: {
        'end-container': {
          hidden: false
        }
      }
    }
  },
  combination: [
    {
      false: {
        false: {
          false: {
            'start-icon': {
              color: '{r_8}'
            },
            'end-icon': {
              color: '{r_9}'
            }
          },
          true: {
            'start-icon': {
              color: '{r_10}'
            },
            'end-icon': {
              color: '{r_11}'
            }
          }
        },
        true: {
          false: {
            'start-icon': {
              color: '{r_12}'
            },
            'end-icon': {
              color: '{r_13}'
            }
          },
          true: {
            'start-icon': {
              color: '{r_14}'
            },
            'end-icon': {
              color: '{r_15}'
            }
          }
        }
      },
      true: {
        false: {
          false: {
            container: {
              behavior: {
                focus: {
                  'border-width': '{r_16}',
                  'border-color': '{r_18}'
                }
              }
            },
            'start-icon': {
              color: '{r_20}',
              behavior: {
                active: {
                  color: '{r_24}'
                }
              }
            },
            'end-icon': {
              color: '{r_21}',
              behavior: {
                active: {
                  color: '{r_25}'
                }
              }
            }
          },
          true: {
            container: {
              behavior: {
                focus: {
                  'border-width': '{r_17}',
                  'border-color': '{r_19}'
                }
              }
            },
            'start-icon': {
              color: '{primary50}',
              behavior: {
                active: {
                  color: '{primary70}'
                }
              }
            },
            'end-icon': {
              color: '{primary50}',
              behavior: {
                active: {
                  color: '{primary70}'
                }
              }
            }
          }
        },
        true: {
          false: {
            container: {
              behavior: {
                focus: {
                  'border-width': '{r_28}',
                  'border-color': '{r_26}'
                }
              }
            },
            'start-icon': {
              color: '{r_30}',
              behavior: {
                active: {
                  color: '{r_34}'
                }
              }
            },
            'end-icon': {
              color: '{r_31}',
              behavior: {
                active: {
                  color: '{r_35}'
                }
              }
            }
          },
          true: {
            container: {
              behavior: {
                focus: {
                  'border-width': '{r_29}',
                  'border-color': '{r_27}'
                }
              }
            },
            'start-icon': {
              color: '{r_32}',
              behavior: {
                active: {
                  color: '{r_34}'
                }
              }
            },
            'end-icon': {
              color: '{r_33}',
              behavior: {
                active: {
                  color: '{r_35}'
                }
              }
            }
          }
        }
      }
    },
    {
      false: {
        true: {
          'start-icon': {
            color: '{r_38}'
          },
          'end-icon': {
            color: '{r_39}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['isInteractive', 'isActive', 'isHovered'],
    ['isInteractive', 'isHalfRated']
  ],
  api: {
    config: {
      size: {
        values: ['medium', 'small', 'large']
      },
      isInteractive: {
        values: [false, true]
      },
      isActive: {
        values: [false, true]
      },
      isHovered: {
        values: [false, true]
      },
      isHalfRated: {
        values: [false, true]
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      'start-container': {
        'clip-value': {
          type: 'clipValueSize',
          name: 'clipValue',
          function: true
        }
      },
      'end-container': {
        'clip-value': {
          type: 'clipValueSize',
          name: '_updatedClipValue'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick',
        onFocus: {
          name: 'onFocus',
          platform: 'web'
        },
        onBlur: {
          name: 'onBlur',
          platform: 'web'
        },
        onHover: {
          name: 'onHover',
          platform: 'web'
        },
        onHoverEnd: {
          name: 'onHoverEnd',
          platform: 'web'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            name: '_role'
          },
          'aria-label': {
            name: 'ariaLabel'
          },
          'aria-checked': {
            name: 'ariaChecked'
          }
        }
      }
    }
  }
};
